import React, { useState, useEffect } from 'react';
import ReactPlayer from '../Global/LazyReactPlayer';
import Modal from '../Global/LazyModal';
import ArrowLgButton from './../Global/ArrowLgButton';
import AudioIcon from '../Global/AudioIcon';
import CloseButton from '../Global/CloseButton';
import CtaLink from '../Global/CtaLink';
import RichText from '../Global/RichText';
//@ts-ignore
import * as styles from './PromotionalstylesA.module.css';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentMedia,
    BrandColor,
    CTALocation,
    KontentNumberValue,
} from '../../../types/KontentProps';
import {
    getColor,
    getMediaData,
    getMultiChoice,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    imagePreset,
    getDisplayDimensions,
} from '../Global/DataUtils';
import LazyImage from '../Global/LazyImage';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import { useIsClient } from '../Global/DataUtils/useIsClient';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import PlayArrow from '../Global/PlayArrow';
import AnchorLink from '../Global/AnchorLink';

type WindowAction = 'New Window' | 'Same Window';
type ImagePositionType = 'right' | 'left' | undefined;
type LinkImg = 'yes' | 'no' | undefined;
type videoIntoLightbox = 'enable' | 'disable' | undefined;

interface videoOrAudiomedia {
    value: {
        url: string;
    }[];
}
interface videoOrAudioFileLocationmedia {
    value: {
        codename: string;
    }[];
}
interface Props extends KontentNumberValue {
    attribution_certification: KontentStringValue;
    attribution_name: KontentStringValue;
    component_anchor_name: KontentStringValue;
    content_panel__content_panel_color: BrandColor;
    content_panel__content_panel_font_color: BrandColor;
    cta_configuration__cta_label: KontentStringValue;
    cta_configuration__cta_location: CTALocation;
    cta_configuration__cta_location_anchor_point: KontentStringValue;
    cta_configuration__cta_window_action: KontentRadioMultiChoice<WindowAction>;
    cta_type: videoOrAudioFileLocationmedia;
    headline: KontentStringValue;
    icon_for_cta_button: KontentMedia;
    paragraph: KontentStringValue;
    primary_image: KontentMedia;
    primary_image_alignment?: KontentRadioMultiChoice<ImagePositionType>;
    anchor_to_lighbox?: KontentRadioMultiChoice<videoIntoLightbox>;
    secondary_image: KontentMedia;
    secondary_image_alignment?: KontentRadioMultiChoice<ImagePositionType>;
    video_or_audioIcono_file: KontentMedia;
    video_or_audio_file_location: videoOrAudioFileLocationmedia;
    video_or_audio_link: KontentStringValue;
    video_or_audio_file?: videoOrAudiomedia;
    link_image?: KontentRadioMultiChoice<LinkImg>;
    kontentItemId?: string;
}

const PromotionalstylesA: React.FC<Props> = ({
    attribution_certification,
    attribution_name,
    component_anchor_name,
    content_panel__content_panel_color,
    content_panel__content_panel_font_color,
    cta_configuration__cta_label,
    cta_configuration__cta_location,
    cta_configuration__cta_window_action,
    cta_type,
    headline,
    icon_for_cta_button,
    paragraph,
    primary_image,
    primary_image_alignment,
    anchor_to_lighbox,
    secondary_image,
    secondary_image_alignment,
    video_or_audio_file,
    video_or_audio_file_location,
    video_or_audio_link,
    cta_configuration__cta_location_anchor_point,
    link_image,
    kontentItemId,
}) => {
    const imgLinked = getMultiChoice(link_image) === 'yes';
    const authImageUrl = getMediaData(secondary_image);
    const url = authImageUrl?.url;
    const [showControl, setShowControl] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [autoplayVideo, setAutoplay] = useState(true);
    const isClient = useIsClient();
    const primaryImage = getImageData(primary_image);
    const videoLink = video_or_audio_link.value;
    const videoLabel = getMediaData(icon_for_cta_button);
    const imagePosition = getMultiChoice(primary_image_alignment);
    const AnchorVideofeat =
        getMultiChoice(anchor_to_lighbox) === 'enable' ? true : false;
    const breakpoints = useBreakpoint();
    const isMobile = !breakpoints.sm;
    const bodyAlignmentClass =
        imagePosition === 'right'
            ? styles.rightAlignBody
            : styles.leftAlignBody;
    const secondaryImagePosition = getMultiChoice(secondary_image_alignment);

    const buttonType = cta_type.value[0]?.codename;
    const textBackgroundColor = getColor(content_panel__content_panel_color);
    const textBackgroundfontColor = getColor(
        content_panel__content_panel_font_color
    );
    const videoOrAudioFileUrl =
        video_or_audio_file?.value.length !== 0
            ? video_or_audio_file?.value[0]?.url
            : '';

    const audioUrl =
        video_or_audio_file_location.value[0]?.codename === 'link'
            ? video_or_audio_link.value
            : videoOrAudioFileUrl;
    const handleClick = () => {
        video_or_audio_file_location.value[0]?.codename === 'attached'
            ? setIsOpen(true)
            : window.open(videoLink, '_blank');
        setAutoplay(true);
    };
    const handleCloseBtnClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        setIsOpen(false);
    };
    const TextColor = textBackgroundfontColor
        ? textBackgroundfontColor
        : undefined;
    const BackgroundColor = textBackgroundColor
        ? textBackgroundColor
        : undefined;

    const ctaHref = cta_configuration__cta_location_anchor_point?.value
        ? BuildLinkHref(cta_configuration__cta_location) +
          '/#' +
          cta_configuration__cta_location_anchor_point?.value
        : BuildLinkHref(cta_configuration__cta_location);

    const ctaTarget =
        getMultiChoice(cta_configuration__cta_window_action) === 'new_window'
            ? '_blank'
            : undefined;

    const componentAnchorValue = component_anchor_name?.value;
    const [anchor, setAnchor] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined' && AnchorVideofeat) {
            setAnchor(window.location.hash.replace('#', ''));
        }
    }, [AnchorVideofeat]);
    useEffect(() => {
        if (
            componentAnchorValue &&
            anchor &&
            (video_or_audio_file?.value[0]?.url || videoLink) &&
            componentAnchorValue === anchor &&
            AnchorVideofeat
        ) {
            setAutoplay(false);
            setIsOpen(true);
        }
    }, [anchor, AnchorVideofeat]);
    return (
        <div
            className={styles.contentWrapper}
            id={componentAnchorValue || undefined}
            data-kontent-item-id={kontentItemId}
        >
            <div className={styles.contentBody + ' ' + bodyAlignmentClass}>
                <div className={styles.videoWrapper}>
                    <div className={styles.modal}>
                        {imgLinked &&
                        cta_configuration__cta_location?.value?.[0]?.elements
                            ?.slug?.url ? (
                            <a
                                href={ctaHref}
                                target={ctaTarget}
                                rel={
                                    ctaTarget === '_blank'
                                        ? 'noopener noreferrer'
                                        : undefined
                                }
                                className={styles.primaryimage}
                                aria-label={
                                    primaryImage?.alt || 'View promotion'
                                }
                            >
                                {primaryImage?.image && (
                                    <div data-kontent-element-codename="primary_image">
                                        <LazyImage
                                            src={
                                                primaryImage.image
                                                    ? optimizeKontentImageUrl(
                                                          (primaryImage.image
                                                              ?.url ||
                                                              primaryImage.image) as string,
                                                          {
                                                              w: 800,
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            srcSet={
                                                primaryImage.image
                                                    ? buildKontentSrcSet(
                                                          (primaryImage.image
                                                              ?.url ||
                                                              primaryImage.image) as string,
                                                          800,
                                                          {
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            sizes="(max-width: 800px) 100vw, 800px"
                                            alt={primaryImage.alt}
                                            {...getDisplayDimensions(
                                                primaryImage.image.width,
                                                primaryImage.image.height,
                                                800
                                            )}
                                            className={styles.primaryimage}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                )}
                            </a>
                        ) : imgLinked &&
                          !cta_configuration__cta_location?.value?.[0]?.elements
                              ?.slug?.url &&
                          cta_configuration__cta_location_anchor_point?.value &&
                          isClient ? (
                            <a
                                href={`${window.location.pathname}#${cta_configuration__cta_location_anchor_point?.value}`}
                                className={styles.primaryimage}
                                aria-label={
                                    primaryImage?.alt || 'View promotion'
                                }
                            >
                                {primaryImage?.image && (
                                    <div data-kontent-element-codename="primary_image">
                                        <LazyImage
                                            src={
                                                primaryImage.image
                                                    ? optimizeKontentImageUrl(
                                                          (primaryImage.image
                                                              ?.url ||
                                                              primaryImage.image) as string,
                                                          {
                                                              w: 800,
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            srcSet={
                                                primaryImage.image
                                                    ? buildKontentSrcSet(
                                                          (primaryImage.image
                                                              ?.url ||
                                                              primaryImage.image) as string,
                                                          800,
                                                          {
                                                              fit: 'crop',
                                                              q: 80,
                                                              auto: 'format',
                                                          }
                                                      )
                                                    : ''
                                            }
                                            sizes="(max-width: 800px) 100vw, 800px"
                                            alt={primaryImage.alt}
                                            {...getDisplayDimensions(
                                                primaryImage.image.width,
                                                primaryImage.image.height,
                                                800
                                            )}
                                            className={styles.primaryimage}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                )}
                            </a>
                        ) : (
                            primaryImage?.image && (
                                <LazyImage
                                    src={
                                        primaryImage.image
                                            ? optimizeKontentImageUrl(
                                                  (primaryImage.image?.url ||
                                                      primaryImage.image) as string,
                                                  {
                                                      w: 800,
                                                      fit: 'crop',
                                                      q: 80,
                                                      auto: 'format',
                                                  }
                                              )
                                            : ''
                                    }
                                    srcSet={
                                        primaryImage.image
                                            ? buildKontentSrcSet(
                                                  (primaryImage.image?.url ||
                                                      primaryImage.image) as string,
                                                  800,
                                                  {
                                                      fit: 'crop',
                                                      q: 80,
                                                      auto: 'format',
                                                  }
                                              )
                                            : ''
                                    }
                                    sizes="(max-width: 800px) 100vw, 800px"
                                    alt={primaryImage.alt}
                                    {...getDisplayDimensions(
                                        primaryImage.image.width,
                                        primaryImage.image.height,
                                        800
                                    )}
                                    className={styles.primaryimage}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                    }}
                                />
                            )
                        )}
                        {buttonType === 'video_play' && (
                            <div
                                className={styles.playArrow}
                                onClick={handleClick}
                            >
                                <PlayArrow
                                    heightWidth="4rem"
                                    strokeColor="#ffffff"
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className={styles.contentBox}
                    style={{
                        backgroundColor: BackgroundColor,
                        color: TextColor,
                    }}
                >
                    {authImageUrl && (
                        <div
                            className={
                                secondaryImagePosition === 'right'
                                    ? styles.image + ' ' + styles.secondaryRight
                                    : styles.image
                            }
                            data-kontent-element-codename="secondary_image"
                        >
                            <LazyImage
                                src={optimizeKontentImageUrl(url as string, {
                                    ...imagePreset.card.desktop,
                                    q: 95,
                                })}
                                srcSet={buildKontentSrcSet(
                                    url as string,
                                    imagePreset.card.desktop.w,
                                    {
                                        fm: 'webp' as const,
                                        q: 95,
                                    }
                                )}
                                sizes="200px"
                                alt={authImageUrl?.description || ''}
                                {...getDisplayDimensions(
                                    authImageUrl?.width,
                                    authImageUrl?.height,
                                    200
                                )}
                            />
                        </div>
                    )}

                    <div className={styles.infoItems}>
                        {headline?.value && (
                            <div className={styles.headline}>
                                <h3 data-kontent-element-codename="headline">
                                    {headline?.value}
                                </h3>
                            </div>
                        )}
                        {paragraph?.value !== '<p><br></p>' && (
                            <div className={styles.paragraph}>
                                {paragraph &&
                                    RichText(
                                        paragraph,
                                        false,
                                        undefined,
                                        undefined,
                                        'paragraph'
                                    )}
                            </div>
                        )}
                        {buttonType === 'standard_button' && (
                            <div className={styles.ctaContainer}>
                                {!cta_configuration__cta_location?.value
                                    ?.length &&
                                cta_configuration__cta_location_anchor_point?.value ? (
                                    <AnchorLink
                                        targetId={
                                            cta_configuration__cta_location_anchor_point?.value
                                        }
                                        color={TextColor}
                                        visualStyle="outlineLight"
                                    >
                                        {cta_configuration__cta_label?.value}
                                    </AnchorLink>
                                ) : (
                                    <CtaLink
                                        href={ctaHref}
                                        target={ctaTarget}
                                        visualStyle="outlineLight"
                                        color={TextColor}
                                    >
                                        {cta_configuration__cta_label?.value}
                                    </CtaLink>
                                )}
                            </div>
                        )}
                        {buttonType === 'audio_file' && (
                            <div
                                className={styles.ctaContainer}
                                onClick={() => {
                                    setShowControl(true);
                                }}
                            >
                                <CtaLink
                                    target={
                                        getMultiChoice(
                                            cta_configuration__cta_window_action
                                        ) === 'new_window'
                                            ? '_blank'
                                            : undefined
                                    }
                                    visualStyle="outlineLight"
                                    color={TextColor}
                                >
                                    {showControl ? (
                                        <div>
                                            <audio
                                                controls
                                                autoPlay
                                                className={styles.audioPlayer}
                                            >
                                                <source
                                                    src={audioUrl}
                                                    type="audio/mpeg"
                                                ></source>
                                            </audio>
                                        </div>
                                    ) : (
                                        <div className={styles.audioLabel}>
                                            <div>
                                                {
                                                    cta_configuration__cta_label?.value
                                                }
                                            </div>
                                            <div style={{ width: 30 }}>
                                                <AudioIcon strokeColor="black"></AudioIcon>
                                            </div>
                                        </div>
                                    )}
                                </CtaLink>
                            </div>
                        )}
                        {attribution_name?.value && (
                            <div
                                className={styles.name}
                                data-kontent-element-codename="attribution_name"
                            >
                                {attribution_name?.value}
                            </div>
                        )}
                        {attribution_certification?.value && (
                            <div data-kontent-element-codename="attribution_certification">
                                {attribution_certification?.value}
                            </div>
                        )}
                    </div>
                </div>
                {video_or_audio_file_location.value[0]?.codename ===
                    'attached' && (
                    <div>
                        <Modal
                            contentLabel="Media"
                            isOpen={modalIsOpen}
                            onRequestClose={() => {
                                setIsOpen(false);
                            }}
                            shouldCloseOnOverlayClick={true}
                            overlayClassName={styles.overlay}
                            style={{
                                content: {
                                    maxWidth: '1200px',
                                    margin: '0 auto',
                                    inset: isMobile
                                        ? '30vh 15px auto'
                                        : '136px 30px 30px',
                                    overflow: 'hidden',
                                    padding: breakpoints.l
                                        ? '20px 15px 20px'
                                        : '20px 15px 3rem',
                                    borderRadius: '1rem',
                                },
                            }}
                        >
                            <div className={styles.closeButton}>
                                <CloseButton
                                    visualStyle="orange"
                                    onClick={handleCloseBtnClick}
                                />
                            </div>
                            <ReactPlayer
                                className={styles.reactPlayer}
                                controls={true}
                                playing={autoplayVideo ? true : false}
                                width="100%"
                                height={isMobile ? '45vw' : '100%'}
                                previewTabIndex={1}
                                url={
                                    video_or_audio_file?.value[0]?.url
                                        ? video_or_audio_file?.value[0]?.url
                                        : video_or_audio_link?.value
                                }
                            />
                        </Modal>
                    </div>
                )}
            </div>
        </div>
    );
};
export default PromotionalstylesA;

export const fragmentPromotionalStyleA = graphql`
    fragment PromotionalStyleA on kontent_item_component___promotional_style_a {
        elements {
            attribution_certification {
                value
            }
            attribution_name {
                value
            }
            component_anchor_name {
                value
            }
            content_panel__content_panel_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            content_panel__content_panel_font_color {
                value {
                    ... on kontent_item_list___brand_colors {
                        id
                        elements {
                            color_hex_value {
                                value
                            }
                        }
                    }
                }
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_type {
                value {
                    codename
                }
            }
            headline {
                value
            }
            icon_for_cta_button {
                value {
                    ... on kontent_item_media___icon {
                        id
                        elements {
                            icon_svg_file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            paragraph {
                ...kontentRichText
            }
            primary_image {
                ...kontentImage
            }
            primary_image_alignment {
                value {
                    codename
                }
            }
            anchor_to_lighbox {
                value {
                    codename
                }
            }
            secondary_image {
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    url
                                    width
                                    height
                                }
                            }
                        }
                    }
                }
            }
            secondary_image_alignment {
                value {
                    codename
                }
            }
            video_or_audio_file {
                value {
                    url
                }
            }
            video_or_audio_file_location {
                value {
                    codename
                }
            }
            video_or_audio_link {
                value
            }
            link_image {
                value {
                    codename
                }
            }
        }
    }
`;
